module.exports = {
      id: "comm-news-usage",
      viewBox: "0 0 223.506 38.837",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-news",
      toString: function () {
        return this.url;
      }
    }